// File: CommentSection.tsx
import React from 'react';
import { FaTrash } from 'react-icons/fa';
import { ReadableDate } from './utils';

export interface Comment {
    _id: number;
    author: string;
    title: string;
    content: string;
    tags: string[];
    type: 'note' | 'discussion';
    replies: Comment[];
    admin: boolean;
    timestamp: string;
    role: string;
}

interface CommentSectionProps {
    comments: Comment[];
    visibleReplies: Set<number>;
    handleReplyClick: (id: number) => void;
    renderReplies: (replies: Comment[]) => JSX.Element[];
    replyTo: number | null;
    replyContent: string;
    handleReplyContentChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    handleReplySubmit: (id: number) => void;
    handleReplyAnonymityChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isAdmin: boolean;
    loginStatus: string;
    MyDiscussions: number[];
    MyReplies: number[];
    handleDelete: (id: number) => void;
    handleReplyDelete: (id: number) => void;
    replyAnonymous: boolean;
    handleReply: (id: number) => void;
}

export const CommentSection: React.FC<CommentSectionProps> = ({
                                                                  comments,
                                                                  visibleReplies,
                                                                  handleReplyClick,
                                                                  renderReplies,
                                                                  replyTo,
                                                                  replyContent,
                                                                  handleReplyContentChange,
                                                                  handleReplySubmit,
                                                                  handleReplyAnonymityChange,
                                                                  isAdmin,
                                                                  loginStatus,
                                                                  MyDiscussions,
                                                                  MyReplies,
                                                                  handleDelete,
                                                                  handleReplyDelete,
                                                                  replyAnonymous,
                                                                  handleReply,
                                                              }) => {
    return (
        <ul className="comments-list">
            {comments.map(comment => (
                <li key={comment._id} className={`comment ${comment.type}`}>
                    <div className="comment-header">
                        <div><p className="comment-type">{comment.type === 'note' ? 'Note' : 'Discussion'}</p></div>
                        <div className="author-flag">
                            <strong>{comment.author}</strong>
                            {comment.admin && <span className="admin-badge">Admin</span>}
                            {(comment.role != '') && <span className="role-badge">{comment.role}</span>}
                        </div>
                        {comment.type === 'discussion' && loginStatus === 'success' && (
                            <div className="reply-section">
                                <button className="reply-button" onClick={() => handleReply(comment._id)}>
                                    Reply
                                </button>
                            </div>
                        )}
                    </div>
                    <p><strong>{comment.title}</strong></p>
                    <p className="comment-content">{comment.content}</p>
                    <div className="tags">
                        {comment.tags.map((tag, index) => (
                            <span key={index} className="tag">{tag}</span>
                        ))}
                    </div>
                    <div className="timestamp">
                        {ReadableDate(comment.timestamp)}
                        {(isAdmin || MyDiscussions.includes(comment._id)) && (
                            <button className="delete-button" title="Delete" onClick={() => handleDelete(comment._id)}>
                                <FaTrash />
                            </button>
                        )}
                    </div>

                    {comment.replies.length > 0 && comment.type === 'discussion' && (
                        <div className="replies-section">
                            <br />
                            <button className="replies-button" onClick={() => handleReplyClick(comment._id)}>
                                {visibleReplies.has(comment._id) ? 'Hide Replies' : 'Show Replies'}
                            </button>
                            {visibleReplies.has(comment._id) && (
                                <ul className="replies-list">
                                    {renderReplies(comment.replies)}
                                    <br />
                                </ul>
                            )}
                        </div>
                    )}

                    {replyTo === comment._id && (
                        <div className="reply-form">
              <textarea
                  value={replyContent}
                  onChange={handleReplyContentChange}
                  placeholder="Write your reply..."
                  required
              />
                            <button className="submit-reply-button" onClick={() => handleReplySubmit(comment._id)}>
                                Submit Reply
                            </button>
                            <div className="radio-group">
                                <label>Keep my name and role private:</label>
                                <input
                                    type="radio"
                                    id={`reply-anonymous-no-${comment._id}`}
                                    value="name"
                                    checked={!replyAnonymous}
                                    onChange={handleReplyAnonymityChange}
                                />
                                <label htmlFor={`reply-anonymous-no-${comment._id}`}>No</label>
                                <input
                                    type="radio"
                                    id={`reply-anonymous-yes-${comment._id}`}
                                    value="anonymous"
                                    checked={replyAnonymous}
                                    onChange={handleReplyAnonymityChange}
                                />
                                <label htmlFor={`reply-anonymous-yes-${comment._id}`}>Yes</label>
                            </div>
                        </div>
                    )}
                </li>
            ))}
        </ul>
    );
};
